// extracted by mini-css-extract-plugin
export default {"container":"CardTitle_container__h3EoC","title":"CardTitle_title__32iph","subTitle":"CardTitle_subTitle__ge-cb"};